import styled from "styled-components";
import Typography from "@material-ui/core/Typography";

const Title = styled(Typography)`
  flex: 1 1 auto;
  white-space: pre;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default Title;
